import axios from "axios"
import rootUrl from "./rootUrl"
import applyConverters from 'axios-case-converter'
import Cookie from './cookie'

const Api = applyConverters(axios.create({
  baseURL: rootUrl({ subdomain: 'api-v2' }),
  transformRequest: [
    (data, headers) => {
      headers.common['X-User-Email'] = Cookie.get('email')
      headers.common['X-User-Token'] = Cookie.get('token')
      return data
    },
    ...axios.defaults.transformRequest
  ]
}))

Api.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if ([401, 403].includes(error.response.status)) {
    window.location = `${ rootUrl({ subdomain: 'app' }) }/login`
  } else {
    return Promise.reject(error);
  }
});

export default Api